import { Table } from '@dixa/lib-shared-habla';

import styles from './conversationsTableFillerCell.module.scss';

export type ConversationsTableFillerCellProps = {
  /** Whether the cell is in the head row. */
  isHeader?: boolean;
};

/** An empty cell before the end-pinned columns that takes up the width the columns leave, so they keep their sizes. */
export const ConversationsTableFillerCell = ({
  isHeader,
}: ConversationsTableFillerCellProps): JSX.Element =>
  isHeader ? (
    <Table.Th columnId={null} role="presentation" className={styles.root} />
  ) : (
    <Table.Td role="presentation" className={styles.root} />
  );
